import React from 'react'
import UserContainerComponent from '../../components/usersComponents/UserContainerComponent';
import { Link } from 'react-router-dom';

function Aprobacion() {
    return (
        <UserContainerComponent>
            <div className='px-4 lg:px-8'>
                <p className='font-bold mt-2 lg:mt-8 text-lg underline'>Aprobaciones Comerciales</p>
                <div>
                    <ul className='pl-4 text-base'>
                        <li><Link className='text-dsBlue font-bold' to={'nueva'}>Realizar Aprobaci&oacute;n Comercial</Link></li>
                        <li><Link className='text-dsBlue font-bold' to={'realizadas'}>Consultar Aprobaciones Comerciales Realizadas</Link></li>
                        <li><Link className='text-dsBlue font-bold' to={'recibidas'}>Consultar Aprobaciones Comerciales Recibidas</Link></li>
                    </ul>
                </div>
            </div>
        </UserContainerComponent>
    )
}

export default Aprobacion;